import React, { Fragment } from 'react';
import SideMenuBar from '../../components/account/SideMenuBar';
import RightBar from '../../components/account/RightBar';
import MessageContent from '../../components/account/MessageContent';
import { isMobilePage } from '../../common/cores';
import TitleBox from '../../components/common/TitleBox';

const Messages = () => {
    return (
        <Fragment>
            <TitleBox title="쪽지함"/>
            <div className="contents_wrap">
                <MessageContent />
            </div>
        </Fragment>
    );
};

export default Messages;


// WEBPACK FOOTER //
// ./src/containers/Account/Messages.js